import { ProtectionT } from 'business/definitions';
import { useSelector } from 'store/hooks';

/**
 * Return the protection affecting a block.
 * @param block - The block to check.
 * @returns The protection affecting the block or undefined if the block is undefined or if it is not affected by a protection.
 */
export const useBlockProtection = (
    block: string | undefined,
): ProtectionT | undefined => {
    const { protections } = useSelector((state) => state.vision);
    if (block === undefined) {
        return undefined;
    }
    return protections.find((protection) => protection.blocks.includes(block));
};
